import { GoPrimitiveDot } from "react-icons/go";
import Data from "../data/data.json";
import Newsletter from "./Newsletter";
import Socials from "./Socials";

const Hero = () => {
  return (
    <div className="relative w-screen h-screen flex justify-center items-center text-center mt-20 pb-28">

      {/* <img src="test images/tailwind-css-icon.webp" className="absolute h-36 filter grayscale opacity-5 bottom-20 left-28 rotate-[15deg] lg:hidden"/>
      <img src="test images/react-icon.png" className="absolute h-52 filter grayscale opacity-5 top-36 left-28 -rotate-12 lg:hidden"/>
      <img src="test images/video-camera-icon.webp" className="absolute h-52 filter grayscale opacity-[2%] top-10 right-28 rotate-12 lg:hidden"/>
      <img src="test images/candlestick-icon.webp" className="absolute h-52 filter grayscale opacity-5 bottom-36 right-28 -rotate-12 lg:hidden"/> */}
      
      <div className="my-40 w-128 sm:mb-10 sm:mt-20">
        <div className="pb-5">
          <h1 className="text-5xl sm:text-4xl">{Data[0].name}</h1>
        </div>
        <div className="flex justify-center">
          <p className="italic font-light flex items-center">Software Engineer ~ Businessman ~ Content Creator</p>
        </div>
        <div className="flex flex-col items-center">
          <Socials />
          <Newsletter />
        </div>
      </div>
    </div>
  );
};

export default Hero;